export default "__VITE_ASSET__de4b6906__"